import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '@/contexts/AdminAuthContext';
import { MapPin, Lock, User } from 'lucide-react';
import { toast } from 'sonner';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { adminLogin, loading } = useAdminAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!username || !password) {
      toast.error('Por favor, preencha todos os campos');
      return;
    }

    const result = await adminLogin(username, password);
    
    if (result.success) {
      toast.success('Login realizado com sucesso!');
      navigate('/admin');
    } else {
      toast.error(result.error || 'Credenciais inválidas');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Logo and Title */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <MapPin className="w-12 h-12" style={{ color: '#302681' }} />
            <h1 className="text-3xl font-bold" style={{ color: '#302681' }}>ParkingSpot</h1>
          </div>
          <h2 className="text-2xl font-semibold text-gray-800">Painel de Administração</h2>
          <p className="text-gray-600 mt-2">Acesso restrito apenas para administradores</p>
        </div>

        {/* Login Form */}
        <div className="bg-white rounded-lg shadow-xl p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Username */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nome de Usuário
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <User className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#302681] focus:border-transparent"
                  placeholder="Digite seu usuário"
                  disabled={loading}
                />
              </div>
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Senha
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#302681] focus:border-transparent"
                  placeholder="Digite sua senha"
                  disabled={loading}
                />
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 px-4 border border-transparent rounded-lg shadow-sm text-white font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ backgroundColor: '#302681' }}
              onMouseEnter={(e) => !loading && (e.target.style.backgroundColor = '#231d61')}
              onMouseLeave={(e) => !loading && (e.target.style.backgroundColor = '#302681')}
            >
              {loading ? 'Entrando...' : '🔓 Entrar como Admin'}
            </button>
          </form>

          {/* Back to Home */}
          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-sm text-gray-600 hover:text-[#302681] transition"
            >
              ← Voltar para o site
            </button>
          </div>
        </div>

        {/* Security Notice */}
        <div className="mt-4 text-center text-xs text-gray-500">
          🔒 Acesso seguro e criptografado
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
